import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import ToastSuccess from 'src/components/atoms/toast/toast-success';
import { resetPasswordData } from 'src/models/user.model';

type TInitialState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  successMessage: string;
};

const initialState: TInitialState = {
  loading: false,
  success: false,
  failure: false,
  successMessage: null as unknown as string,
};

export const resetPassword = createAsyncThunk('reset-password/put', async (data: resetPasswordData, { rejectWithValue }) => {
  try {
    const response: AxiosResponse<string> = await axios.put(`/api/user/reset-password`, data);

    toast(ToastSuccess('Password aggiornata con successo'));

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState,
  reducers: {
    resetPasswordState: (): TInitialState => {
      return { loading: false, success: false, failure: false, successMessage: null as unknown as string };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetPassword.pending, (state): TInitialState => {
        return { ...state, loading: true, success: false, failure: false };
      })
      .addCase(resetPassword.fulfilled, (state, action): TInitialState => {
        return {
          ...state,
          loading: false,
          success: true,
          successMessage: action.payload,
        };
      })
      .addCase(resetPassword.rejected, (state): TInitialState => {
        return { ...state, loading: false, failure: true };
      });
  },
});

export const { resetPasswordState } = passwordResetSlice.actions;

export default passwordResetSlice.reducer;
